import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { I18nContext, initReactI18next } from "react-i18next";
import { createElement, useEffect, useState } from "react";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: ["common", "validation", "auth", "project", "user", "media", "help"],
    defaultNS: "common",
    fallbackNS: "common",
    fallbackLng: "en",
    react: {
      nsMode: "fallback",
    },
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    detection: {
      order: ['navigator'],
      lookupCookie: undefined,
      caches: [],
      excludeCacheFor: ["cookies"]
    }
  });

export function I18nextProvider({ children }) {
  const [value, setValue] = useState({ i18n });
  useEffect(() => {
    if (import.meta.hot) {
      import.meta.hot.on('i18n-hot-reload:locales-update', async () => {
        await i18n.reloadResources();
        setValue({ i18n });
      });
    }
  }, []);
  return createElement(I18nContext.Provider, { value }, children);
}